"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var loadFacebookSdk_1 = require("../../utils/loadFacebookSdk");
exports.FacebookLogin = function (props) {
    var FB;
    var appId = props.appId, elementId = props.elementId, culture = props.culture, authType = props.authType, size = props.size, maxRows = props.maxRows, className = props.className, buttonType = props.buttonType, width = props.width, useContinueAs = props.useContinueAs, autoLogoutLink = props.autoLogoutLink, onLogin = props.onLogin, scope = props.scope, defaultAudience = props.defaultAudience, onSdkLoad = props.onSdkLoad, onStatusChange = props.onStatusChange;
    React.useEffect(function () {
        loadFacebookSdk_1.default({ appId: appId, version: 'v2.8', xfbml: true }, elementId, culture)
            .then(function (facebook) {
            FB = facebook;
            onSdkLoad(FB);
            FB.Event.subscribe('auth.statusChange', onStatusChange);
        });
        return function () { return FB ? FB.Event.unsubscribe('auth.statusChange', onStatusChange) : null; };
    }, []);
    var nonDataValues = {
        className: "fb-login-button " + className,
        auth_type: authType
    };
    return (React.createElement("div", __assign({}, nonDataValues, { "data-onlogin": onLogin, "data-size": size, "data-max-rows": maxRows, "data-button-type": buttonType, "data-width": width, "data-use-continue-as": useContinueAs, "data-auto-logout-link": autoLogoutLink, "data-scope": scope, "data-default-audience": defaultAudience })));
};
exports.FacebookLogin.defaultProps = {
    authType: 'rerequest',
    maxRows: 1,
    size: 'small',
    buttonType: 'continue_with',
    autoLogoutLink: false,
    useContinueAs: true,
    width: 'auto',
    onLogin: undefined,
    scope: 'public_profile',
    defaultAudience: 'friends',
    className: '',
    onSdkLoad: function () { return null; },
    onStatusChange: function () { return null; }
};
exports.FacebookLogin.displayName = 'FacebookLogin';
//# sourceMappingURL=FacebookLogin.js.map